import React, { useEffect } from 'react';
import { Card, Button, Typography, theme, Spin, message } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import RoomForm from './roomForm';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/AppRedux/reducers';
import { roomDetailsGetRequest , roomDetailsUpdateRequest } from '@/AppRedux/actions/admin/roomDetailConfig';
import { RoomData } from '@/AppRedux/actions/admin/roomDetailConfig/roomDetailConfigType';

const { Title, Text } = Typography;

const EditRoom: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { roomCode, propcode } = useParams<{ roomCode: string, propcode: string }>();

    const { token } = theme.useToken();
    const { loading, roomData, process } = useSelector((state: RootState) => state.roomDetailConfig);
    const normalizedRoomCode = roomCode ? decodeURIComponent(roomCode).toUpperCase() : '';

    useEffect(() => {
        if (!normalizedRoomCode) {
            message.error('Invalid room code.');
            navigate(-1);
            return;
        }

        dispatch(roomDetailsGetRequest(normalizedRoomCode));
    }, [dispatch, navigate, normalizedRoomCode]);

    useEffect(() => {
        if (process.action === 'ROOM_DETAILS_GET_REQUEST' && !loading && !process.status) {
            message.error(process.message || `Room "${normalizedRoomCode}" not found.`);
            navigate(-1);
        }
        else if (process.action === 'ROOM_DETAILS_UPDATE_REQUEST' && !loading) {
            if (process.status) {
                message.success('Room updated successfully!');
                setTimeout(() => {
                    navigate(-1);
                }, 300)
            } else {
                message.error(process.message || 'Failed to update room.');
            }
        }
    }, [process, loading, navigate, normalizedRoomCode]);


    const handleSubmit = async (values:RoomData) => {
        console.log('Updating room with data:', values);
        
        const updatedRoomData = { ...roomData, ...values };
        // Here you would typically send the data to your backend API
        dispatch(roomDetailsUpdateRequest(updatedRoomData));
        /*
        setTimeout(() => {
            console.log('Form Data Submitted: ', values);
            Modal.info({
                title: 'Saved JSON Data', width: 800,
                content: <pre style={{ maxHeight: 400, overflow: 'auto' }}>{JSON.stringify(values, null, 2)}</pre>,
                onOk: () => {
                },
            });
        }, 1000);*/
    };

    const handleCancel = () => {
        navigate(-1);
    };

    if (loading) {
        return (
            <div style={{ padding: 24, background: token.colorBgLayout, minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                <Spin size="large" description="Loading room data..." />
            </div>
        );
    }

    if (!roomData) {
        return <div style={{ padding: 24 }}>Room not found.</div>;
    }

    const headerDisplayName = roomData.contents.find(c => c.lang === 'en')?.display_name || roomData.contents[0]?.display_name || '...';

    return (
        <div style={{ maxWidth: 1000, margin: '0 auto' }}>
            <Card>
                {/* Header */}
                <div style={{ marginBottom: 32 }}>
                    <Button
                        type="text"
                        icon={<ArrowLeftOutlined />}
                        onClick={handleCancel}
                        style={{ marginBottom: 16 }}
                    >
                        Back to Room List
                    </Button>
                    <Title level={2} style={{ margin: 0 }}>
                        Edit Room
                    </Title>
                    <Text type="secondary">
                        Update room information for {headerDisplayName}
                    </Text>
                </div>

                {/* Form */}
                <RoomForm
                    mode="edit"
                    initialData={roomData}
                    onSubmit={handleSubmit}
                    onCancel={handleCancel}
                    propCode={propcode === "newsoft" ? "sample" : propcode || ""}
                />
            </Card>
        </div>
    );
};

export default EditRoom;
